export default __webpack_public_path__ + "media/images/svg/arch-border-0ed7c0f57134c49479a1ec85642e6a98.svg";